import { DeliveryItemList as BaseItemList } from '../DeliveryItemList';
import { useDeliveryContext } from './DeliveryContext';
import { DeliveryItem } from '../../types';
import { ReactNode } from 'react';

export interface ItemListProps<T extends DeliveryItem> {
    label: string;
    renderItem?: (item: T) => ReactNode;
}

export const ItemList = <T extends DeliveryItem, P>(
    props: ItemListProps<T>,
) => {
    const { validItems, selectedIds, toggleSelection } = useDeliveryContext<
        T,
        P
    >();

    return (
        <BaseItemList
            items={validItems}
            selectedIds={selectedIds}
            onToggle={toggleSelection}
            {...props}
        />
    );
};
